// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    StyleProps as CheckboxStyleProps,
} from "@insite/mobius/Checkbox/Checkbox";
import { IconWrapper } from "@insite/mobius/Icon";
import Minus from "@insite/mobius/Icons/Minus";
import Plus from "@insite/mobius/Icons/Plus";
import { productListFilterAccordionSectionStyles } from "@tps/Overrides/Widgets/ProductList/ProductListFilterAccordionSection";
import { styledScrollbar } from "@tps/XDL/Utilities";
import { css } from "styled-components";

productListFilterAccordionSectionStyles.checkBoxGroup = {
    css: css`
        width: 100%;
        padding: 0px 0 5px 0;
    `,
};

productListFilterAccordionSectionStyles.checkBox = {
    css: css<CheckboxStyleProps>`
        align-items: flex-start;
    `,
    typographyProps: {
        css: css`
            word-break: break-all;
        `,
    },
};

productListFilterAccordionSectionStyles.checkBoxSelected = {
    css: css<CheckboxStyleProps>`
        align-items: flex-start;
    `,
    typographyProps: {
        css: css`
            word-break: break-all;
        `,
    },
};

productListFilterAccordionSectionStyles.seeAllLink = {
    typographyProps: {
        size: 12,
        weight: "bold",
        lineHeight: "13px",
    },
    icon: {
        iconProps: {
            size: 12,
            src: Plus,
        },
        position: "left",
    },
    css: css`
        margin-top: 7px;
        ${IconWrapper} {
            margin-right: 8px;
            opacity: 0.66;
        }
    `,
} 

productListFilterAccordionSectionStyles.seeLessLink = {
    typographyProps: {
        size: 12,
        weight: "bold",
        lineHeight: "13px",
    },
    icon: {
        iconProps: {
            size: 12,
            src: Minus,
        },
        position: "left",
    },
    css: css`
        margin-top: 7px;
        ${IconWrapper} {
            margin-right: 8px;
            opacity: 0.66;
        }
    `,
};

productListFilterAccordionSectionStyles.filtersWrapper = {
    css: css`
        max-height: 280px;
        ${styledScrollbar(4)}
    `,
};

productListFilterAccordionSectionStyles.fancyScrollStyles = {
    css: css`
        span[class^="ScrollIndicator"] {
            height: 8px;
        }
    `,
};

productListFilterAccordionSectionStyles.accordionSection = {
    headerProps: {
        css: css`
            &&&& button,
            &&&& button:focus {
                border-top: 0;
            }
        `,
    },
};
